export const PRODUCT_WATCH_URL = 'product-watch'

export const PRODUCT_WATCH_TRANSACTION_PATH = `/project/:id/${PRODUCT_WATCH_URL}`
export const PRODUCT_WATCH_DETAIL_TRANSACTION_PATH = `/project/:id/${PRODUCT_WATCH_URL}/:productWatchId`
